import InputDefault from "../../../../../../shared/Inputs/InputDefault";

const EmailBlock = ({ user, email, setEmail, emailPlaceholder }) => {
    const totalBonus = (user.personalBonus || 0) + (user.hasDepositBonus ? 50 : 0);

    return (
        <div className="promo-block">
            <div className="d-flex">
                { !user.email
                    ? <InputDefault value={email} setValue={setEmail} placeholder={"Введіть вашу електронну адресу"} />
                    : <InputDefault value={email} setValue={setEmail} placeholder={emailPlaceholder} />
                }
            </div>
            <div className="promo-bonus-info">
                {
                    totalBonus
                        ? `Ваш особистий бонус до будь-якої суми +${totalBonus}%`
                        : `Поповнений баланс не підлягає поверненню`
                }
            </div>
        </div>
    );
};

export default EmailBlock;